import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppVideoPlusPage } from './app-video-plus';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppVideoPlusPage,
  ],
  imports: [
    IonicPageModule.forChild(AppVideoPlusPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppVideoPlusPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-video-plus/app-video-plus.module.ts